import { applyMiddleware, combineReducers, compose, legacy_createStore as createStore, Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable-es6-compat';

import { reducers, PlaylistRemoteAppState, rootEpic, xhrApi, sseApi, defaultState } from './store';

const appReducer = combineReducers(reducers);
export const rootReducer = (state: PlaylistRemoteAppState, action) => {
  if (action.type === 'RESET_STATE') {
    sseApi.close();
    state = undefined;
    window.location.href = '/login';
  }
  return appReducer(state, action);
};
const composeEnhancers = typeof (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== 'undefined'
  ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(
    {
      serialize: {
        options: true
      }
    }
  )
  : compose;

const epicMiddleware = createEpicMiddleware({
  dependencies: {
    restApi: xhrApi,
    sseApi,
  }
});
const middlewares = [
  epicMiddleware,
];
export const store: Store<PlaylistRemoteAppState> = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);

// @ts-ignore
window.store = store;

epicMiddleware.run(rootEpic);
